function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.547 13.582l-4.42-4.34a.854.854 0 00-1.195.004.826.826 0 00.002 1.18l2.967 2.912H7.846a.84.84 0 00-.846.835c0 .46.379.834.846.834H17.9l-2.966 2.913a.827.827 0 00-.003 1.18.854.854 0 001.196.003l4.418-4.339a.828.828 0 000-1.182z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13.25,
  stroke: "currentColor",
  strokeWidth: 1.5
});

var SvgRouterNavArrow = function SvgRouterNavArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjU0NjYgMTMuNTgyM0wxNi4xMjc1IDkuMjQyOTVDMTUuNzk2NSA4LjkxNzk0IDE1LjI2MTEgOC45MTkxNSAxNC45MzE3IDkuMjQ1NzlDMTQuNjAyMiA5LjU3MjM5IDE0LjYwMzUgMTAuMTAwNiAxNC45MzQ1IDEwLjQyNTdMMTcuOTAxIDEzLjMzODVINy44NDU1OEM3LjM3ODU3IDEzLjMzODUgNyAxMy43MTIxIDcgMTQuMTcyOUM3IDE0LjYzMzcgNy4zNzg1NyAxNS4wMDcyIDcuODQ1NTggMTUuMDA3MkgxNy45MDA5TDE0LjkzNDUgMTcuOTJDMTQuNjAzNSAxOC4yNDUxIDE0LjYwMjMgMTguNzczMyAxNC45MzE3IDE5LjA5OTlDMTUuMjYxMiAxOS40MjY2IDE1Ljc5NjYgMTkuNDI3NyAxNi4xMjc2IDE5LjEwMjdMMjAuNTQ1OSAxNC43NjQyQzIwLjg3NzEgMTQuNDM4MSAyMC44NzY4IDEzLjkwNzMgMjAuNTQ2NiAxMy41ODIzWiIgZmlsbD0iY3VycmVudENvbG9yIi8+CjxjaXJjbGUgY3g9IjE0IiBjeT0iMTQiIHI9IjEzLjI1IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjUiIC8+Cjwvc3ZnPgo=";
export { SvgRouterNavArrow as ReactComponent };